import React from "react";
import { ShieldCheck, Lock, Zap } from "lucide-react";

const SecureReliable = () => {
  const features = [
    {
      id: 1,
      title: "Enterprise Security",
      description:
        "Bank-level encryption and security protocols protect your sensitive business data and surveys responses.",
      icon: <ShieldCheck size={28} className="text-white" />,
    },
    {
      id: 2,
      title: "DPDC Compliant",
      description:
        "Full compliance with DPDC regulations and data protection laws for global operations.",
      icon: <Lock size={28} className="text-white" />,
    },
    {
      id: 3,
      title: "99.9% Uptime",
      description:
        "Reliable infrastructure ensures your surveys are always available when you need them most.",
      icon: <Zap size={28} className="text-white" />,
    },
  ];

  return (
    <section className="py-16 px-6 lg:px-12 bg-gray-800 font-sans">
      <div className="max-w-6xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-white">
          Secure & Reliable
        </h2>
        <p className="text-gray-400 mt-2 mb-12">
          Your data and responses are always encrypted and protected
        </p>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center text-center space-y-4"
            >
              {/* Icon Box */}
              <div className="flex items-center justify-center w-14 h-14 rounded-lg bg-green-600 shadow-md">
                {feature.icon}
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-white">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-400 text-[16px]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecureReliable;
